const dataStorage = {}

export const getStorage = (key) => {
  try {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
  } catch (error) {
    console.error('Error accessing localStorage, returning value from fallback storage:', error)
    return dataStorage[key] ? JSON.parse(dataStorage[key]) : null
  }
}

export const setStorage = ({ key, value }) => {
  const stringValue = JSON.stringify(value)
  try {
    localStorage.setItem(key, stringValue)
  } catch (error) {
    console.error('Error accessing localStorage, saving to fallback storage:', error)
    dataStorage[key] = stringValue
  }
}
